var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74794 13.76C7.55594 13.76 7.37993 13.696 7.23593 13.552L4.05195 10.368C3.76395 10.08 3.76395 9.63201 4.05195 9.34401C4.33995 9.05601 4.78793 9.05601 5.07593 9.34401L7.76394 12.016L14.1479 5.648C14.4359 5.36 14.8839 5.36 15.1719 5.648C15.4599 5.936 15.4599 6.38401 15.1719 6.67201L8.27593 13.552C8.11593 13.696 7.93994 13.76 7.74794 13.76Z",
    fill: "#FAFAFA",
    stroke: "#FAFAFA",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f80c4ccff16749d1a7b4113ec52f6269.svg";
export { ForwardRef as ReactComponent };